import { createAction } from '@sde/widgets-core/src/redux/helpers/createAction';
import { SET_PROVIDER } from './constants';

export const setProvider = (provider) => {
  return createAction({
    type: SET_PROVIDER,
    payload: provider,
  });
};
